// src/theme.js

import { createTheme } from '@mui/material/styles';

// Función para generar un tema personalizado basado en colores primarios y secundarios
const getTheme = (colorPrimario, colorSecundario) => {
  return createTheme({
    palette: {
      primary: {
        main: colorPrimario,
      },
      secondary: {
        main: colorSecundario,
      },
      background: {
        default: '#f5f5f5',
      },
      text: {
        primary: '#333333',
      },
    },
    typography: {
      fontFamily: 'Arial, sans-serif',
      h1: {
        fontSize: '2rem',
        fontWeight: 'bold',
      },
      h2: {
        fontSize: '1.5rem',
        fontWeight: 'bold',
      },
    },
  });
};

// Tema Predeterminado para la Aplicación
const defaultTheme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#ffcc00',
    },
    background: {
      default: '#f5f5f5',
    },
    text: {
      primary: '#333333',
    },
  },
  typography: {
    fontFamily: 'Arial, sans-serif',
    h1: {
      fontSize: '2rem',
      fontWeight: 'bold',
    },
    h2: {
      fontSize: '1.5rem',
      fontWeight: 'bold',
    },
  },
});

export { getTheme };
export default defaultTheme;
